var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 26.9954C25 24.4312 27.0787 22.3525 29.6429 22.3525H50.3571C52.9213 22.3525 55 24.4312 55 26.9954V52.7097C55 55.2739 52.9213 57.3525 50.3571 57.3525H29.6429C27.0787 57.3525 25 55.2739 25 52.7097V26.9954ZM30 34.8525C30 36.2333 31.1193 37.3525 32.5 37.3525H47.5C48.8807 37.3525 50 36.2333 50 34.8525C50 33.4718 48.8807 32.3525 47.5 32.3525H32.5C31.1193 32.3525 30 33.4718 30 34.8525ZM32.5 42.3525C31.1193 42.3525 30 43.4718 30 44.8525C30 46.2332 31.1193 47.3525 32.5 47.3525H42.5C43.8807 47.3525 45 46.2332 45 44.8525C45 43.4718 43.8807 42.3525 42.5 42.3525H32.5Z",
    fill: "#16B979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70ZM40 75C20.67 75 5 59.33 5 40C5 20.67 20.67 5 40 5C59.33 5 75 20.67 75 40C75 59.33 59.33 75 40 75Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2.5H45V12.5H35V2.5Z",
    fill: "#3375F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 67.5H45V77.5H35V67.5Z",
    fill: "#3375F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 32.5H77.5V42.5H67.5V32.5Z",
    fill: "#16B979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 32.5H12.5V42.5H2.5V32.5Z",
    fill: "#16B979"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon_contract.68e07cd7e4da6cee3e7b9858f8fd16b3.svg";
export { ForwardRef as ReactComponent };